import { render, staticRenderFns } from "./RelatorioVencedores.vue?vue&type=template&id=8b8c1f2c&"
import script from "./RelatorioVencedores.vue?vue&type=script&lang=js&"
export * from "./RelatorioVencedores.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioVencedores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports